"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_padding_selector_html_1 = __importDefault(require("./widget-padding-selector.html"));
(function (module) {
    'use strict';
    function WidgetPaddingController($scope, $filter, $timeout, pageLayout, globalOptions, metricImperial) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        var translate = $filter('translate');
        var GLOBAL_DEFAULT_PADDING = '16px';
        angular.extend($ctrl, {
            // everything else is custom
            PADDING_OPTIONS: {
                '0px': 'NONE',
                '8px': 'COMPACT',
                '16px': 'NORMAL',
                '24px': 'SPACIOUS'
            },
            $onInit: function () {
                if (!$ctrl.label) {
                    $ctrl.label = translate('MARGIN');
                }
                $ctrl.unitLabel = metricImperial.getUnitLabel($ctrl.unit).toLowerCase();
                // make sure it is null or valid
                if (!isValidPadding($ctrl.padding)) {
                    $ctrl.padding = getDefaultPadding();
                }
                // init our to-inches in case it is custom
                $ctrl.paddingNums = paddingToNums($ctrl.padding);
                // finally reset if they are all the same
                if ($ctrl.padding) {
                    var split = $ctrl.padding.split(' ');
                    if (split.length === 4 && !_.without(split, split[0]).length && $ctrl.PADDING_OPTIONS[split[0]]) {
                        $ctrl.padding = split[0];
                    }
                }
            },
            $onChanges: function (changeObj) {
                // when unit changes, reprocess numbers and set label
                if (changeObj.unit && !changeObj.unit.isFirstChange()) {
                    $ctrl.unit = changeObj.unit.currentValue;
                    $ctrl.unitLabel = metricImperial.getUnitLabel($ctrl.unit).toLowerCase();
                    $ctrl.paddingNums = getConvertedPaddingNums($ctrl.paddingNums);
                }
                if (changeObj.padding) {
                    $ctrl.paddingNums = paddingToNums($ctrl.padding);
                }
            },
            initCustomStyle: function () {
                $ctrl.padding = expandPadding($ctrl.padding);
                $ctrl.paddingNums = paddingToNums($ctrl.padding);
            },
            resetPadding: function () {
                var first = $ctrl.paddingNums[0], padding = paddingFromNums([first]);
                // if each is the same as the first and is valid, use it
                if ($ctrl.PADDING_OPTIONS[padding] && !_.without($ctrl.paddingNums, first).length) {
                    $ctrl.padding = padding;
                }
                else {
                    // else use the default
                    $ctrl.padding = getDefaultPadding();
                }
                $ctrl.change($ctrl.padding);
            },
            onPaddingNumChange: function () {
                var prevPadding = $ctrl.padding;
                $ctrl.padding = paddingFromNums($ctrl.paddingNums);
                if (prevPadding !== $ctrl.padding) {
                    $ctrl.change($ctrl.padding);
                }
            },
            change: function (padding) {
                $ctrl.onChange({
                    $padding: padding
                });
            },
            getDefaultLabel: function () {
                return translate('DEFAULT') + ' (' +
                    translate($ctrl.PADDING_OPTIONS[globalOptions.getWidgetPadding()] || 'CUSTOM') +
                    ')';
            },
            getMenuItems: function () {
                var ret = [];
                _.forEach($ctrl.PADDING_OPTIONS, function (value, key) {
                    ret.push({
                        label: translate(value),
                        value: key
                    });
                });
                if ($ctrl.allowDefault) {
                    ret.splice(0, 0, {
                        label: this.getDefaultLabel(),
                        value: null
                    }, {
                        divider: true
                    });
                }
                return ret;
            },
            useInch: function () {
                return metricImperial.useInch($ctrl.unit);
            }
        });
        function getDefaultPadding() {
            return $ctrl.allowDefault ? null : GLOBAL_DEFAULT_PADDING;
        }
        function isValidPadding(padding) {
            return (!padding && $ctrl.allowDefault) ||
                _.isString(padding) && ($ctrl.PADDING_OPTIONS[padding] ||
                    padding.split(' ').length === 4);
        }
        function expandPadding(padding) {
            padding = padding || globalOptions.getWidgetPadding();
            if (padding.split(' ').length > 1) {
                return padding;
            }
            return _.fill(new Array(4), parseInt(padding, 10)).join('px ') + 'px';
        }
        function paddingToNums(padding) {
            var split = padding && padding.split(' ');
            if (!padding || split.length !== 4) {
                return [0, 0, 0, 0];
            }
            return _.map(split, function (p) {
                // round to the nearest 0.05 inch
                var inchNum = parseFloat(Math.round(parseInt(p) / pageLayout.PX_TO_IN / 0.05) * 0.05);
                if (!$ctrl.useInch()) {
                    return metricImperial.getCMOfInch(inchNum);
                }
                return inchNum;
            });
        }
        function paddingFromNums(nums) {
            return _.reduce(nums, function (rule, num) {
                if (!$ctrl.useInch()) {
                    num = metricImperial.getInchOfCM(num);
                }
                // round to the nearest 4px
                return rule + (Math.round(num * pageLayout.PX_TO_IN / 4) * 4) + 'px ';
            }, '').trim();
        }
        function getConvertedPaddingNums(nums) {
            return _.map(nums, function (num) {
                if ($ctrl.useInch()) {
                    return metricImperial.getInchOfCM(num);
                }
                return metricImperial.getCMOfInch(num);
            });
        }
    }
    WidgetPaddingController.$inject = [
        '$scope',
        '$filter',
        '$timeout',
        'prPageLayoutService',
        'pr.globalOptionsService',
        'prMetricImperial',
    ];
    module.component('prWidgetPaddingSelector', {
        templateUrl: widget_padding_selector_html_1.default,
        controller: WidgetPaddingController,
        bindings: {
            label: '<',
            allowDefault: '@?',
            padding: '<',
            unit: '<',
            onChange: '&'
        }
    });
})(angular.module('qualtrics.pr'));
